import axios from 'redaxios';

import tabs from '../features/tabs';
import {makeGridSwatches} from '../features/swatch';
import {register} from '../vendor/theme-scripts/theme-sections';
import hideElement from '../util/hide-element';
import slideDown from '../util/slide-down';
import {Slider} from '../features/product-slider';
import {recentProducts} from '../features/recent-products';

const selectors = {
  dataRelatedSectionElem: '[data-related-section]',
  dataRelatedProduct: '[data-grid-item]',
  dataLimit: 'data-limit',
  dataMinimum: 'data-minimum',
  recentlyViewed: '[data-recent-wrapper]',
  recentlyViewedWrapper: '[data-recently-viewed-wrapper]',
  recentlyProduct: '[data-recently-viewed-products]',
  slider: '[data-slider]',
};

class Related {
  constructor(section) {
    this.section = section;
    this.sectionId = section.id;
    this.container = section.container;

    this.init();

    this.container.addEventListener('recent-products:added', () => {
      this.recent();
    });
  }

  init() {
    const relatedSection = this.container.querySelector(selectors.dataRelatedSectionElem);

    if (!relatedSection) {
      return;
    }
    const productId = relatedSection.getAttribute('data-product-id');
    const limit = relatedSection.getAttribute('data-limit');
    const route = window.theme.routes.product_recommendations_url || '/recommendations/products/';
    const requestUrl = `${route}?section_id=related&limit=${limit}&product_id=${productId}`;

    axios
      .get(requestUrl)
      .then(function (response) {
        const fresh = document.createElement('div');
        fresh.innerHTML = response.data;

        const inner = fresh.querySelector(selectors.dataRelatedSectionElem);

        if (inner.querySelector(selectors.dataRelatedProduct)) {
          const innerHtml = inner.innerHTML;
          hideElement(relatedSection);
          relatedSection.innerHTML = innerHtml;
          slideDown(relatedSection);

          makeGridSwatches(relatedSection.parentElement);

          if (relatedSection.querySelector(selectors.slider)) {
            new Slider(relatedSection, relatedSection.querySelector(selectors.slider));
          }
        } else {
          relatedSection.dispatchEvent(
            new CustomEvent('tabs:hideRelatedTab', {
              bubbles: true,
            })
          );
        }
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

  recent() {
    const recentlyViewedHolder = this.container.querySelector(selectors.recentlyViewed);
    const recentlyViewedWrapper = this.container.querySelector(selectors.recentlyViewedWrapper);
    const recentProducts = this.container.querySelectorAll(selectors.dataRelatedProduct);

    const minimumNumberProducts = recentlyViewedHolder.hasAttribute(selectors.dataMinimum) ? parseInt(recentlyViewedHolder.getAttribute(selectors.dataMinimum)) : 4;
    const checkRecentInRelated = !recentlyViewedWrapper && recentProducts.length > 0;
    const checkRecentOutsideRelated = recentlyViewedWrapper && recentProducts.length >= minimumNumberProducts;

    if (checkRecentInRelated || checkRecentOutsideRelated) {
      recentlyViewedHolder.dispatchEvent(
        new CustomEvent('tabs:checkRecentTab', {
          bubbles: true,
        })
      );

      makeGridSwatches(this.container);

      if (recentlyViewedHolder.querySelector(selectors.slider)) {
        new Slider(recentlyViewedHolder, recentlyViewedHolder.querySelector(selectors.slider));
      }
    }
  }
}

const relatedSection = {
  onLoad() {
    this.section = new Related(this);
  },
};

register('related', [relatedSection, tabs, recentProducts]);
